import React, { Component } from "react";

class TextArea extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: this.props.defaultValue ?? "",
    };
  }

  render() {
    const {
      register,
      errors,
      label,
      name,
      rules,
      className,
      labelClassName,
      labelStyles,
      styles,
    } = this.props;

    return (
      <>
        <div className={`flex flex-col items-start ${className}`}>
          <label
            className={`form-label font-bold float-start mb-1 ${labelClassName}`}
            style={labelStyles}
          >
            {rules?.required && <span className="text-red-500">*</span>} {label}
          </label>

          <textarea
            {...register(name, rules)}
            className="block p-2 w-full text-sm text-gray-900  rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500 "
            style={styles}
          ></textarea>

          {errors[name] && (
            <span className="text-red-500 text-sm">{errors[name].message}</span>
          )}
        </div>
      </>
    );
  }
}

export default TextArea;
